import { useState, useEffect, useCallback } from 'react';
import { getRequest } from '../api/ApiController';

/**
 * Zoznam strojov s kartou (machine_cards): donačítava sa z API (už nie v state pri logine).
 * @param {{ enabled?: boolean }} options - ak enabled === false, načítavanie sa nespustí (použitie napr. pri lazy taboch)
 * @returns {{ machineCards: Array, loading: boolean, refetch: function }}
 */
export function useMachineCards(options = {}) {
  const enabled = options.enabled !== false;
  const [machineCards, setMachineCards] = useState([]);
  const [loading, setLoading] = useState(enabled);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refetch = useCallback(() => {
    if (!enabled) return;
    setRefreshTrigger((t) => t + 1);
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setMachineCards([]);
      return;
    }
    setLoading(true);
    getRequest('/api/machine_cards')
      .then((r) => {
        const list = r?.data ?? r ?? [];
        setMachineCards(Array.isArray(list) ? list : []);
      })
      .catch(() => setMachineCards([]))
      .finally(() => setLoading(false));
  }, [enabled, refreshTrigger]);

  return { machineCards, loading, refetch };
}
